import React from "react";
import { useState, useEffect } from "react";
import { isUndefined } from "lodash";

const Timer = ({ minute, second, isSuccess, expireAction }) => {

  const [minutes, setMinutes] = useState(!isUndefined(minute) ? minute : 3);
  const [seconds, setSeconds] = useState(!isUndefined(second) ? second : 0);

  useEffect(() => {
    let interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  });

  useEffect(() => {
    if (minutes === 0 && seconds === 0) {
      expireAction()
    }
  }, [expireAction, minutes, seconds])

  return (
    <div className="timer-container">
      {minutes === 0 && seconds === 0 && !isSuccess && (
        <span className="color-red-100 font-size-11">00:00</span>
      )}
      {!isSuccess && seconds > 0 && (
        <div>
          <span className="color-main-100 font-size-11 line-height-15">
            {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
          </span>
        </div>
      )}
    </div>
  );
};

export default Timer;
